import React from 'react';
export const BonusesSection = () => {
  const bonuses = [{
    num: '01',
    icon: '🍎',
    title: 'Cocina Vital 60+',
    subtitle: 'Recetas simples y menú semanal',
    desc: 'Recetas simples, menú semanal y lista de compras orientativa para organizar mejor la alimentación cotidiana.',
    price: '$15.000 ARS'
  }, {
    num: '02',
    icon: '👥',
    title: 'Kit de Socialización',
    subtitle: 'Cartas de recuerdos y dinámicas familiares',
    desc: 'Cartas de recuerdos, juegos simples y dinámicas familiares para fortalecer la conexión entre generaciones.',
    price: '$12.000 ARS'
  }, {
    num: '03',
    icon: '🏠',
    title: 'Checklist Hogar Seguro',
    subtitle: 'Revisión habitación por habitación',
    desc: 'Guía para revisar baño, dormitorio, cocina, pasillos e iluminación y detectar riesgos en casa.',
    price: '$8.000 ARS'
  }];
  return <section className="bg-familia-section py-10 md:py-16 px-4 md:px-6" data-id="element-20">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-21">
        <div className="text-center mb-10 md:mb-16" data-id="element-22">
          <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold mb-4 md:mb-6" data-id="element-23">
            🎁 MÁS LOS 3 BONOS EXCLUSIVOS
          </h2>
          <p className="text-familia-gray text-[15px] md:text-lg" data-id="element-24">
            Incluidos siempre — sin costo extra
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 mb-10 md:mb-16" data-id="element-25">
          {bonuses.map((b, i) => <div key={i} className="bg-familia-card border border-familia-gold/25 p-6 md:p-8 rounded-2xl relative flex flex-col" data-id="element-26">
              <div className="absolute -top-3 left-6 md:left-8 bg-familia-gold text-familia-bg font-bold text-xs py-1 px-3 rounded" data-id="element-27">
                BONO {b.num}
              </div>
              <div className="text-4xl md:text-5xl mb-4 md:mb-6 mt-2" data-id="element-28">
                {b.icon}
              </div>
              <h3 className="text-lg md:text-xl font-display font-bold mb-1" data-id="element-29">
                {b.title}
              </h3>
              <p className="text-familia-gold text-xs sm:text-sm font-semibold mb-3" data-id="element-30">
                {b.subtitle}
              </p>
              <p className="text-familia-gray text-[14px] md:text-sm leading-relaxed mb-6 md:mb-8 flex-grow" data-id="element-31">
                {b.desc}
              </p>
              <div className="flex items-center justify-between pt-4 md:pt-6 border-t border-white/10" data-id="element-32">
                <span className="text-familia-red line-through text-sm" data-id="element-33">
                  Valor real: {b.price}
                </span>
                <span className="text-familia-green font-bold" data-id="element-34">GRATIS ✅</span>
              </div>
            </div>)}
        </div>
        <div className="bg-familia-bg border-2 border-familia-gold rounded-2xl p-6 md:p-8 text-center max-w-md mx-auto" data-id="element-35">
          <p className="text-familia-gray text-sm mb-2" data-id="element-36">
            Valor total de los 3 bonos:
          </p>
          <p className="text-familia-red text-2xl md:text-3xl font-display font-bold line-through mb-3 md:mb-4" data-id="element-37">
            $35.000 ARS
          </p>
          <div className="bg-familia-gold text-familia-bg font-bold py-3 px-6 rounded-xl mb-3 md:mb-4 text-base md:text-lg" data-id="element-38">
            🎁 GRATIS — incluidos con tu compra de hoy
          </div>
        </div>
      </div>
    </section>;
};